export default "__VITE_ASSET__Oa2My$dy__"